export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
  disabled?: boolean // 添加disabled属性用于控制是否可点击
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    // 添加会议管理导航项
    {
      name: 'meetings',
      displayName: '会议管理', // 需要在语言文件中添加对应的翻译
      meta: {
        icon: 'event_note', // 使用会议相关的图标
      },
      disabled: true, // 设置为不可点击
      children: [
        {
          name: 'meetings-list',
          displayName: '会议列表', // 需要在语言文件中添加对应的翻译
        },
        {
          name: 'templates-list',
          displayName: '模板列表', // 需要在语言文件中添加对应的翻译
        },
      ],
    },
  ] as INavigationRoute[],
}
